module.exports = __webpack_public_path__ + "139927a88251aefa1de428141343b1f2.pdf";